<h2 mat-dialog-title i18n="@@deviceAttributeFieldsTitle">Add device attribute fields</h2>

<mat-dialog-content>
  <p i18n="@@deviceAttributeFieldsIntro">
    In a device attachment, technicians edit these values of the attachment's device.
  </p>
  @if (categories().length === 0) {
    <p i18n="@@deviceAttributeFieldsNone">
      No product category has attributes editable per device.
    </p>
  } @else {
    <mat-form-field appearance="outline" style="width: 100%">
      <mat-label i18n="@@deviceAttributeFieldsCategory">Product category</mat-label>
      <mat-select [(ngModel)]="categoryUuid" (selectionChange)="categoryChanged()">
        @for (category of categories(); track category.uuid) {
          <mat-option [value]="category.uuid">{{ category.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    @for (attribute of attributes(); track attribute.key) {
      <div>
        <mat-checkbox
          [checked]="selected.has(attribute.key)"
          [disabled]="isAdded(attribute)"
          (change)="toggle(attribute, $event.checked)"
        >
          {{ attribute.name }} [{{ attribute.key }}]
          @if (isAdded(attribute)) {
            <span i18n="@@deviceAttributeFieldsAdded">(already added)</span>
          }
        </mat-checkbox>
      </div>
    }

    <mat-form-field appearance="outline" style="width: 100%; margin-top: 12px">
      <mat-label i18n="@@deviceAttributeFieldsPlace">Add to</mat-label>
      <mat-select [(ngModel)]="section">
        <mat-option [value]="null" i18n="@@deviceAttributeFieldsTopLevel">Fields (no section)</mat-option>
        @for (name of data.sections; track $index; let i = $index) {
          <mat-option [value]="i">{{ name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button matButton type="button" (click)="cancel()" i18n="@@deviceAttributeFieldsCancel">Cancel</button>
  <button
    matButton="filled"
    type="button"
    [disabled]="selected.size === 0"
    (click)="add()"
    i18n="@@deviceAttributeFieldsAdd"
  >
    Add
  </button>
</mat-dialog-actions>
